import React, { useEffect, useState } from 'react';
import '../header.css';
import './userProfile.css';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

import { HeaderType } from '@/components/Layout/Header/Header';
import SignInAccounts from '@/features/auth/components/SignInAccounts';
import NotificationData from './NotificationData';
import UserAuth from '@/components/Authentication/UserAuth';
import NotificationDataAdmin from './NotificationDataAdmin';
import NotificationDataAgency from './NotificationDataAgency';
import i18next from 'i18next';
import ReactSwitch from 'react-switch';
import { styled } from '@mui/material/styles';
import Switch, { SwitchProps } from '@mui/material/Switch';
import firebase from 'firebase/compat/app';

const UserProfile = ({ type = HeaderType.LANDING }: { type?: HeaderType }) => {
  const [checked, setChecked] = React.useState('');
  const auth = useAuth();
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate('/auth/login');
  };
  const [val, setVal] = useState('');

  useEffect(() => {
    if (auth?.user?.role == 'admin') {
      setVal('admins');
    } else if (auth?.user?.role == 'agency') {
      setVal('agency');
    } else if (auth?.user?.role == 'lawyer') {
      setVal('lawyer');
    } else {
      setVal('all');
    }
  }, [auth?.user?.role]);

  const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    '& .MuiSwitch-switchBase': {
      margin: 1,
      padding: 0,
      transform: 'translateX(6px)',
      '&.Mui-checked': {
        color: '#fff',
        transform: 'translateX(22px)',
        '& .MuiSwitch-thumb:before': {
          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
            '#fff'
          )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
        },
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be', // Conditionally set backgroundColor
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#ff385c', // Conditionally set backgroundColor
      width: 32,
      height: 32,
      '&::before': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          '#fff'
        )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
      },
    },
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be', // Conditionally set backgroundColor
      borderRadius: 20 / 2,
    },
  }));

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    const mode = value ? 'dark' : 'light';
    setChecked(mode);
    document.body.className = mode;
    localStorage.setItem('theme', mode);
  };

  const signOut = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        console.log('User signed out.');
      })
      .catch((error) => {
        console.log('Sign-out error:', error);
      });
  };

  return (
    <>
      <div className="d-flex dash-men align-items-center">
        {auth.user ? (
          <>
            {val === 'admins' && <NotificationDataAdmin />}
            {val === 'all' && <NotificationData />}
            {val === 'agency' && <NotificationDataAgency />}
          </>
        ) : (
          <button
            className="d-flex sds justify-content-center align-items-center text-black py-2 pe-3 text-md br-50 user-icon  bell"
            type="button"
            onClick={handleNavigate}
          >
            <i className="fa-regular fa-bell"></i>
          </button>
        )}
        {val === 'agency' || val === 'lawyer' || val === 'admins' ? null : (
          <UserAuth click={() => navigate('/user/favourite-list')}>
            {/* <UserAuth click={() => navigate('/')}> */}
            <button
              className="d-flex justify-content-center align-items-center text-black  px-3 text-md br-50 user-icon"
              type="button"
            >
              <i className="fa-regular fa-heart"></i>
            </button>
          </UserAuth>
        )}
        <div className="dropdown login-vendor d-flex align-items-center">
          {val === 'agency' ? (
            <button
              className="d-flex justify-content-center align-items-center text-black py-2 px-3 text-md br-50 user-icon dropdown-toggle leftMr"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa-regular fa-user" />
            </button>
          ) : (
            <>
              <button
                className="d-flex justify-content-center align-items-center text-black py-2 px-3 text-md br-50 user-icon dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-regular fa-user" />
              </button>
              <MaterialUISwitch
                sx={{ m: 1 }}
                checked={checked === 'dark'}
                onChange={handleChange}
              />
            </>
          )}
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            {false && type}
            {auth.user ? (
              <>
                {auth.user.role === 'admin' ? (
                  <>
                    <li>
                      <Link className="dropdown-item" to={`/admin`}>
                        <i className="fa-solid fa-gauge" /> {i18next.t('Dashboard')}
                      </Link>
                    </li>
                  </>
                ) : (
                  <>
                    {auth.user.role == 'agency' ? (
                      <li>
                        <Link className="dropdown-item" to={`/agency`}>
                          <i className="fa-regular fa-user" /> {i18next.t('Agency')}
                        </Link>
                      </li>
                    ) : (
                      <>
                        {auth.user.role == 'lawyer' ? (
                          <li>
                            <Link className="dropdown-item" to={`/lawyer`}>
                              <i className="fa-regular fa-user" /> {i18next.t('Lawyer')}
                            </Link>
                          </li>
                        ) : (
                          <li>
                            <Link className="dropdown-item" to={`/user/profile`}>
                              <i className="fa-regular fa-user" /> {i18next.t('Profile')}
                            </Link>
                          </li>
                        )}
                      </>
                    )}
                  </>
                )}

                <li className="border-top">
                  <a onClick={() => auth.logout()} className="dropdown-item" href="#">
                    <i className="fa-solid fa-right-from-bracket" /> {i18next.t('Logout')}
                  </a>
                </li>
              </>
            ) : (
              <>
                <li>
                  <SignInAccounts>
                    <a className="dropdown-item">
                      <i className="fa-solid fa-users"></i>
                      {i18next.t('Login Customer')}
                    </a>
                  </SignInAccounts>
                </li>
                <li>
                  <a
                    role="button"
                    className="dropdown-item"
                    onClick={() => navigate('/auth/login-agency')}
                  >
                    <i className="fa-solid fa-people-roof"></i> {i18next.t('Login Agency')}
                  </a>
                </li>
                <li>
                  <a
                    role="button"
                    className="dropdown-item"
                    onClick={() => navigate('/auth/login-lawyer')}
                  >
                    <i className="fa-solid fa-user-secret"></i> {i18next.t('Login Lawyer')}
                  </a>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default UserProfile;
